export default class ConsolGeocoder {
  constructor(mapOptions) {
	  this.defaultCountry = mapOptions.defaults.countryName;
	  this.defaultISO3Country = mapOptions.defaults.countryISO3;
	  this.mapOptions = mapOptions;
  }

  geocodeAddress = (geocodeOptions, address, cb, errorCb) => {
    var url =
      geocodeOptions.url + "?q=" + address + "&in=countryCode:" + this.defaultISO3Country + "&apiKey=" + geocodeOptions.options.apiKey + "&show=streetInfo&types=address";

    const geocodedAddress = address;

    fetch(url)
      .then((res) => res.json())
      .then(
        (result) => {
			
		  if(!result || !result.items || result.items.length == 0) {
			 errorCb({
			 	errorReason: 'notfound'
			 });
		  } else {
			  $('.geocodeErrorDetails').hide();
		  }

          var data = [];
          for (var i = 0; i < result.items.length; i++) {
            var item = result.items[i];

            var dataResult = {
              lat: item.position.lat,
              lng: item.position.lng,
              address: item.address,
              streetInfo: item.streetInfo ? item.streetInfo[0] : {},
              addressString: item.title,
              markerType: "base",
              relevance: item.scoring.queryScore,
              geocodedAddress: geocodedAddress
            };

            data.push(dataResult);

            cb(data);
          }
        },
        (error) => {
			errorCb({
				error: error
			});
		}
      );
  };
  
  validateLatLngOfAddressModel = (addressObj) => {
    var ret = !!addressObj && !!addressObj.gpsLatitude && !!addressObj.gpsLongitude;
    return ret;
  };

  validateAddress = (addressObj) => {
    var baseFields = !!(
      addressObj &&
      addressObj.suburb &&
      addressObj.state &&
      addressObj.postcode
    );
    
    // missing one of the base fields, bail
    if(!baseFields) return false;
    
    // if theres a street address, then thats a free input field for a full street address
    if(addressObj.streetAddress) return true;
    
    // Otherwise segmented address
    return !!(
		addressObj.streetNumber &&
		addressObj.streetName &&
		addressObj.streetType
	);
  };
  
  fillHiddenFieldsWithGeocodeAddress = (data, status) => {
	  
	var geocodeAddressObj = data.address;
	var streetInfo = data.streetInfo;
	  
    $('#hiddenFieldSuburb').val(geocodeAddressObj.district);
    $('#hiddenFieldPostcode').val(geocodeAddressObj.postalCode);
    $('#hiddenFieldState').val(geocodeAddressObj.stateCode);

	// This is the address as the user entered it
	$('#hiddenFieldGeocodingAddress').val(data.geocodedAddress);		
	
	// TODO - These used to be different in the previous version of the here geocoding api, but now I only have label		
	$('#hiddenFieldMappedFullAddress').val(geocodeAddressObj.label);		
	$('#hiddenFieldFormattedAddress').val(geocodeAddressObj.label);	
	  
	$('#hiddenFieldStreetNumber').val(geocodeAddressObj.houseNumber);
	$('#hiddenFieldStreetName').val(streetInfo.baseName);
	
	if(streetInfo.streetType) {
		$('#hiddenFieldStreetType').val((streetInfo.streetType).toUpperCase());
	} else {
		$('#hiddenFieldStreetType').val(undefined);
	}
	
	$('#hiddenFieldGpsLatitude').val(data.lat);
	$('#hiddenFieldGpsLongitude').val(data.lng);
	  
    // ACCEPTED - user manually accepted a result APPLIED - only one result returned
    $('#hiddenFieldGeocodingStatus').val(status);
    
    $('#hiddenFieldRelevance').val(data.relevance);
  }
  
  fillInputFieldsWithGeocodeAddress = (data, status) => {
	  
	var geocodeAddressObj = data.address;
	var streetInfo = data.streetInfo;
	  
	$('.mapSuburbInput').val(geocodeAddressObj.district);
	$('.mapPostcodeInput').val(geocodeAddressObj.postalCode);
	$('.mapStateInput').val(geocodeAddressObj.stateCode);
	
	if($('.mapStreetAddressInput').length > 0) {
		// Freehand address input
		$('.mapStreetAddressInput').val(this.createStreetAddress(geocodeAddressObj));
		
	} else {
		// Structured address input
		$('.mapStreetNumberInput').val(geocodeAddressObj.houseNumber);
		$('.mapStreetNameInput').val(streetInfo.baseName);
		$('.mapStreetTypeInput').val((streetInfo.streetType).toUpperCase());
	}
	
	this.fillHiddenFieldsWithGeocodeAddress(data, status);
  };
  
  createStreetAddress = (geocodeAddressObj) => {
	  
	  if (!geocodeAddressObj) return;
	  
	  var ret = "";
	  
	  // units??
	  
	  if (geocodeAddressObj.houseNumber) {
	      ret += geocodeAddressObj.houseNumber + " ";
	  }
	  
	  if (geocodeAddressObj.street) {
	      ret += geocodeAddressObj.street;
	  }
	
	  return ret;
  };
  
  toFullAddressString = (addressObj, includeCountry) => {
    if (!addressObj) return;

    var ret = "";

	if(addressObj.streetAddress) {
		ret += addressObj.streetAddress;
	} else {
	
	    if (addressObj.unitFloor) {
	      ret += addressObj.unitFloor + "/";
	    }
	    if (addressObj.streetNumber) {
	      ret += addressObj.streetNumber + " ";
	    }
	    if (!addressObj.streetType && addressObj.streetNameAndType) {
	      // street type cannot be parsed / recognised
	      ret += addressObj.streetNameAndType;
	    } else {
	      if (addressObj.streetName) {
	        ret += addressObj.streetName + " ";
	      }
	      if (addressObj.streetTypeName) {
	        ret += addressObj.streetTypeName;
	      } else if (addressObj.streetType) {
	        ret += addressObj.streetType;
	      }
	      if (addressObj.streetSuffix) {
	        ret += " " + addressObj.streetSuffix;
	      }
	    }
    }

    if (addressObj.suburb) {
      if (ret) ret += ", ";
      ret += addressObj.suburb;
    }
    if (addressObj.state) {
      if (ret) ret += ", ";
      ret += addressObj.state;
    }
    if (addressObj.postcode) {
      if (ret) ret += " ";
      ret += addressObj.postcode;
    }
    if (includeCountry) {
      if (addressObj.country) {
        if (ret) ret += ", ";
        ret += addressObj.country;
      } else {
      	if (ret) {
        	ret += ", " + this.defaultCountry;
        }
      }
    }
    return ret;
  };
}
